// hooks
import { useQuery } from '@tanstack/react-query';

// config
import apiRequest from '../../config/apiRequest';

export const useMyInfoRequest = () => {
  const { isLoading: myInfoIsLoading, data } = useQuery(['userInfo'], () =>
    apiRequest({
      method: 'GET',
      endpoint: 'auth/me'
    })
  );

  return {
    myInfo: data?.data || {},
    myInfoIsLoading
  };
};
